import { render } from "./presupuestoCard.vue?vue&type=template&id=34b72e2d&scoped=true"
import script from "./presupuestoCard.vue?vue&type=script&lang=js"
export * from "./presupuestoCard.vue?vue&type=script&lang=js"

import "./presupuestoCard.vue?vue&type=style&index=0&id=34b72e2d&lang=css"
import "./presupuestoCard.vue?vue&type=style&index=1&id=34b72e2d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34b72e2d"]])

export default __exports__